import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      background: '#fff',
      borderRadius: rem(16),
      padding: rem(8),
      display: 'flex',
      gap: rem(24),
      [theme.fn.smallerThan('sm')]: {
        padding: rem(16),
        flexDirection: 'column',
        gap: rem(16),
      },
    },
    heading: {
      borderLeft: `5px solid ${theme.colors.primaryBase}`,
      paddingLeft: 12,
    },
    slider: {
      [theme.fn.largerThan('sm')]: {
        width: rem(230),
      },
    },
    name: {
      color: '#262626',
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      [theme.fn.largerThan('sm')]: {
        width: `calc(100% - 230px - 24px)`,
      },
      [theme.fn.smallerThan('sm')]: {
        gap: rem(16),
      },
    },
    mainInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(4),
      alignItems: 'flex-start',
    },
    prices: {
      display: 'flex',
      gap: rem(8),
      alignItems: 'flex-end',
      marginBottom: rem(4),
    },
    mainPrice: {
      color: theme.colors.red[8],
    },
    originPrice: {
      textDecoration: 'line-through',
      color: '#595959',
    },
    actionRows: {
      display: 'table',
    },
    actionRow: {
      display: 'table-row',
    },
    actionCol: {
      display: 'table-cell',
      verticalAlign: 'middle',
      padding: '4px 0',
    },
    actionLabel: {
      width: rem(110),
      whiteSpace: 'nowrap',
      paddingRight: rem(8),
    },
    promotionTags: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(4),
    },
    actions: {
      display: 'flex',
      gap: rem(8),
    },
    amountInput: {
      width: rem(40),
      input: {
        textAlign: 'center',
      },
    },
    amountBtn: {
      width: rem(32),
      background: theme.colors.neutral[0],
      borderColor: theme.colors.neutral[0],
    },
    cartBtn: {},
    buyBtn: {
      [theme.fn.smallerThan('sm')]: {
        flexGrow: 1,
      },
      [theme.fn.largerThan('sm')]: {
        minWidth: rem(182),
      },
    },
    amountControl: {
      display: 'flex',
      gap: rem(8),
    },
  }
})
